import { createAppSlice } from '@exp/redux/createAppSlice';

import { getGuidelinesByPart, getPromoStores } from '../js/common/api';

export const sortStores = ({ endDate: a }, { endDate: b }) => {
  if (a && !b) {
    return -1;
  }

  if (b && !a) {
    return 1;
  }

  return a.localeCompare(b);
};

const slice = createAppSlice({
  name: 'promoBanner',
  initialState: {
    fetchPendingPromoStores: false,
    guidelinesByPart: new Map(),
    promoStores: null,
  },
  reducers: (create) => ({
    fetchGuidelinesByPart: create.asyncThunk(
      ({ storeIds, parts }) => getGuidelinesByPart(storeIds, parts),
      {
        options: {
          condition: (_, { getState }) => {
            const { promoStores: { guidelinesByPart } } = getState();
            return _.storeIds?.length
              && _.storeIds.some((storeId) => !guidelinesByPart?.get(storeId)?.fetchPending);
          },
        },
        pending: (state, action) => {
          action.meta.arg.storeIds.forEach((storeId) => state.guidelinesByPart.set(storeId, {
            fetchPending: true,
          }));
        },
        fulfilled: (state, action) => {
          action.meta.arg.storeIds.forEach((storeId) => state.guidelinesByPart.set(storeId, {
            fetchPending: false,
            guidelines: new Map(action.payload.data[storeId]
              ?.map((o) => [o.name, o])),
          }));
        },
        rejected: (state, action) => {
          action.meta.arg.storeIds.forEach((storeId) => state.guidelinesByPart.set(storeId, {
            fetchPending: false,
            guidelines: new Map(),
          }));
        },
      },
    ),

    fetchPromoStores: create.asyncThunk(
      () => getPromoStores(),
      {
        options: {
          condition: (_, { getState }) => {
            const { promoStores: { fetchPendingPromoStores } } = getState();
            return !fetchPendingPromoStores;
          },
        },
        pending: (state) => { state.fetchPendingPromoStores = true; },
        fulfilled: (state, action) => {
          state.fetchPendingPromoStores = false;
          state.promoStores = action.payload.data;
        },
        rejected: (state) => { state.fetchPendingPromoStores = false; },
      },
    ),
  }),
});

export const { fetchGuidelinesByPart, fetchPromoStores } = slice.actions;
export default slice.reducer;
